
export class WorkflowplanAppointment {
  text: string;
  description: string;
  startDate: Date;
  endDate: Date;
  recurrenceRule?: string;
}
